import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import PersonalizedCare from './PersonalizedCare';

export default function Blog() {
  return (
    <>
        <Navbar />
        <PersonalizedCare />
        <Footer />
        <Copyright />
    </>
  )
}